export default __webpack_public_path__ + "static/media/skatebanner.68ac2fe8.jpeg";